import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import ClientTable from "../components/ClientTable";
import { getPageName } from "../../../locales/translationUtils";
import { useTranslation } from 'react-i18next';
import NavBar, { NavBarItem } from "../../../components/NavBar";
import { GridColDef } from "@mui/x-data-grid";
import AlertOverlay from "../../../components/Alert";
import { useClient } from "../../../apis/client/ClientProvider";
import Paginacao from "../../../types/paginacao";
import Client from "../../../types/client";
import { FaEdit } from "react-icons/fa";

const ClientView: React.FC = () => {
    const { t } = useTranslation();
    const { clients, apiResponse, fetchClient } = useClient();
    const navigate = useNavigate();
    const location = useLocation();
    const [alert, setAlert] = useState<{ message: string; variant: "success" | "danger" | "warning" | "info" } | null>(null);

    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 20,
        page: 0,
    });

    const [paginacao, setPaginacao] = React.useState({
        pageNum: 0,
        quantityPerPage: 20
    } as Paginacao);
    
    useEffect(() => {
        const newPaginacao = {
            ...paginacao, 
            pageNum: paginationModel.page,
            quantityPerPage: paginationModel.pageSize
        };
        setPaginacao(newPaginacao);
        fetchClient(newPaginacao);
    }, [paginationModel]);

    useEffect(() => {
        if (location.state?.message) {
            setAlert({ message: location.state.message, variant: location.state.variant });
    
            navigate(location.pathname, { replace: true });
    
            const timeout = setTimeout(() => setAlert(null), 5000);
            return () => clearTimeout(timeout);
        }
    }, [location, navigate]);
     
    const navItems: NavBarItem[] = [
        { label: t('client.labels.home'), route: "/", iconName: "house-door" },
        { label: t('client.labels.new'), route: "/Client/create", iconName: "plus-circle" },
    ];

    const columns: GridColDef[] = [
        {
            field: "id",
            headerName: t('client.fields.id'),
            width: 80,
            renderCell: (params) => (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "black",
                    cursor: "pointer"
                }}
                onClick={() => navigate(`/client/${params.row.id}`)}>
                    <FaEdit className="text-primary" style={{ marginRight: "6px", marginLeft: "2px" }}/>
                    {params.row.id}
                </span>
            ),
        },
        { field: "cnpj", headerName: t('client.fields.cnpj'), width: 200 },
        { field: "name", headerName: t('client.fields.name'), width: 350 },
        { 
            field: "color", 
            headerName: t('client.fields.color'), 
            width: 150,
            renderCell: (params) => (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <div style={{ 
                        display: "inline-block",
                        backgroundColor: `#${params.row.color}`,
                        borderRadius: "4px",
                        border: "1px solid black",
                        width: "24px",
                        height: "24px",
                        marginRight: "4px" 
                    }}></div>
                    <span
                        style={{
                            display: "inline-block"
                        }}
                    >
                        {(params.row.color && params.row.color.length === 6 ) ? `#${params.row.color}` : "#"}
                    </span>
                </div>
            )
        },
    ];

    return (
          <Container fluid style={{ height: 'calc(100vh - 200px)', overflow: 'auto'}}>
            <NavBar items={navItems} />
            <div className="mb-3"></div>
            <h2>{getPageName("client")}</h2>
            <div className="mb-3"></div>
            <div>
            {alert && (
                <AlertOverlay
                    message={alert.message}
                    variant={alert.variant}
                    onClose={() => setAlert(null)}
                />
            )}
        </div>
            <ClientTable
                rows={clients || [] as Client[]}
                columns={columns}
                getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row")}
                apiResponse={apiResponse} 
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
            />
        </Container>
    );
};

export default ClientView;